/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

import {
  DateRange
} from '../'

export const FilterDateRange = ({ title, startDate, endDate, onStartDateChange, onEndDateChange, minDate, maxDate,
  dateFormat, showTimeSelect, timeFormat, showYearDropdown, showMonthDropdown, timeIntervals }) => (
  <div className="sidebar__item slds-p-top_medium slds-p-right_large slds-p-bottom_small slds-p-left_large">
    <div className="slds-grid slds-wrap">
      <div className="slds-col slds-size_1-of-1 sidebar__item__title">
        {title}
      </div>
      <div className="slds-col slds-size_3-of-4">
        <div className="sidebar__item__choice">
          <DateRange
            startDate={startDate}
            endDate={endDate}
            onStartDateChange={onStartDateChange}
            onEndDateChange={onEndDateChange}
            startDatePlaceholder='From'
            endDatePlaceholder='To'
            minDate={minDate
              ? moment(minDate)
              : undefined
            }
            maxDate={maxDate
              ? moment(maxDate)
              : undefined
            }
            dateFormat={showTimeSelect ? `${dateFormat}, ${timeFormat}`: dateFormat}
            align='vertical'
            showTimeSelect={showTimeSelect}
            timeIntervals={timeIntervals}
            timeFormat={timeFormat}
            showYearDropdown={showYearDropdown}
            showMonthDropdown={showMonthDropdown}
            dropdownMode={showYearDropdown || showMonthDropdown ? 'select' : undefined}
          />
        </div>
      </div>
    </div>
  </div>
)

FilterDateRange.propTypes = {
  title: PropTypes.string,
  startDate: PropTypes.instanceOf(moment),
  endDate: PropTypes.instanceOf(moment),
  onStartDateChange: PropTypes.func.isRequired,
  onEndDateChange: PropTypes.func.isRequired,
  dateFormat: PropTypes.string,
  minDate: PropTypes.instanceOf(moment),
  maxDate: PropTypes.instanceOf(moment),
  showTimeSelect: PropTypes.bool,
  timeFormat: PropTypes.string,
  showYearDropdown: PropTypes.bool,
  showMonthDropdown: PropTypes.bool,
  timeIntervals: PropTypes.number
}

FilterDateRange.defaultProps = {
  title: 'Date range',
  dateFormat: 'DD MMM YYYY',
  minDate: undefined,
  maxDate: undefined,
  showTimeSelect: false,
  timeFormat: 'HH:mm',
  showYearDropdown: false,
  showMonthDropdown: false
}



// WEBPACK FOOTER //
// ./src/components/filter-date-range/index.js